<template>
  <div class="flex-column flex-halign-center flex-valign-center home-view">
    <div class="banner-bg"/>
    <div class="flex-column home-container">
      <div class="banner">
        <div class="title">{{ title }}</div>
        <div class="sub-title">{{ subTitle }}</div>
      </div>
      <div class="search flex-column">
        <div>
          <el-input v-model="search">
            <el-button slot="append">检索</el-button>
          </el-input>
        </div>
        <div>
          <span class="mr10">大模型</span>
          <span class="mr10">智能体</span>
        </div>
      </div>
      <div class="func flex-row flex-halign-between">
        <template v-for="(item, index) in funcList">
          <CompCard :title="item.title" :tip="item.tip" :key="index"/>
        </template>
      </div>
      <div class="flex-row list">
        <el-menu :default-active="activeIndex"
                 class="menu"
                 mode="vertical"
                @select="handleActiveChange">
          <el-menu-item index="hot">
            <span class="title">热点</span>
          </el-menu-item>
          <el-menu-item index="new">
            <span class="title">新事物</span>
          </el-menu-item>
        </el-menu>

        <el-tabs v-show="activeIndex === 'hot'"
                 tab-position="top"
                 style="margin-left: 20px; width: 100%;">
          <el-tab-pane label="用户管理">ss</el-tab-pane>
          <el-tab-pane label="配置管理">ce</el-tab-pane>
        </el-tabs>

        <el-tabs v-show="activeIndex === 'new'"
                 tab-position="top"
                 style="margin-left: 20px; width: 100%;">
          <el-tab-pane label="feds">ss</el-tab-pane>
          <el-tab-pane label="sdf">ce</el-tab-pane>
        </el-tabs>

      </div>
    </div>
  </div>
</template>
<script>
import CompCard from './func-card'

export default {
  name: 'ViewHome',
  components: {CompCard},
  data() {
    return {
      title: '云平台',
      subTitle: '云平台',
      search: '',
      funcList: [],
      activeIndex: 'hot',
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.funcList = [
        {title: '平台整合', tip: '数据治理·低代码·动态大屏等一站式解决方案'},
        {title: '服务开发', tip: '模型治理·动态API·开发配置发布上线流程化管理'},
        {title: '运维管控', tip: '服务·资源运行过程中全方位检测；审计管理·链路追踪·告警平台随时掌握健康状态'},
        {title: '权限管理', tip: '统一认证平台，统一网关管理，安全访问云平台；提供基于角色安全的权限体系'},
      ]
    },
    handleActiveChange(val) {
      console.log('dddddddd', val)
      this.activeIndex = val;
    }
  }
}
</script>

<style lang="less" scoped>
.home-view {
  position: relative;
  height: 100%;

  .banner-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 370px;
    background-image: url("../../assets/img/home_bg.png");
  }
}

.home-container {
  width: 1200px;
  height: 100%;
  z-index: 2;

  .banner {
    padding: 10px 0;
    margin-top: 30px;

    .title {
      font-size: 36px;
      font-weight: 700;
    }

    .sub-title {
      padding: 10px 0;
      font-size: 14px;
    }
  }

  .search {
    padding: 30px 20px;
    background-color: rgba(55, 100, 255, 0.2);
  }

  .func {
    width: 100%;
    height: 180px;
    padding: 10px 0;
    margin-top: 30px;
  }
  .list {
    .menu {
      .title {
        font-size: 18px;
        font-weight: 600;
        width: 100px;
        display: block;
        color: #555555;
      }
    }
    :deep(.el-menu-item.is-active) {
      border-right: 4px solid ;
      background-color: rgba(221, 236, 255, 1);
    }
  }
}
</style>
